<template>
    <div class="page-breadcrumbs">
        <page-breadcrumbs :list="breadcrumbs" />
    </div>
    <h2 class="page-title">
        Invite new user
    </h2>
    <invite-form
        @saved="router.push({name: 'ss-users.invited'})"
        @cancel="router.push({name: 'ss-users.invited'})"
    />
</template>

<script setup>
import {ref} from 'vue'
import InviteForm from './InviteForm'
import {useRoute, useRouter} from 'vue-router'
import PageBreadcrumbs from '~/base/components/page-breadcrumbs/PageBreadcrumbs'

const route = useRoute()
const router = useRouter()
const breadcrumbs = ref([
    {
        title: '..',
        path: '/'
    },
    {
        title: 'Invited Users',
        name: 'ss-users.invited'
    },
    {
        title: 'Invite new user',
    }
])
</script>
